import ApiClient from './ApiClient'

export default class AdminClient extends ApiClient {
    login = ({ email, password }) => this.post('/sign_in', { email, password })

    signup = ({ organization, email, password }) => this.post('/sign_up', { organization, email, password })

    changePass = ({ oldPass, newPass }) => this.put('/reset_password', { oldPass, newPass })
}
